<template>
    <div class="content">
        <div class="admission" @click="showModal" v-if="admission">入学咨询</div>
        <div class="ctx" v-if="info" v-show="!cover">
            <div class="banner">
                <img :src="info.banner"/>
            </div>
            <div class="detail">
                <div class="tab" v-if="tabs">
                    <div class="tab-item" :class="{active: tab===i}" @click="tab=i" v-for="(t, i) in tabs" :key="i">
                        {{t.name}}
                        <span class="tab-line" :style="{width: t.name.length + 'em'}"></span>
                    </div>
                </div>
                <div class="tab-ctx">
                    <ul class="live-list" v-if="list">
                        <li class="live-item" v-for="(l, i) in list" :key="i" @click="goToLive(l)">
                            <div class="live-img" :style="{backgroundImage: `url(${l.cover})`}">
                                <div class="live-play"></div>
                                <div class="live-time" :class="[`status-${l.status}`]" v-if="l.status">{{l.statusText + ' | ' + l.startText}}</div>
                                <div class="live-time status-not" v-else>敬请期待</div>
                            </div>
                            <div class="live-info">
                                <div class="live-txt">
                                    <div class="live-title">{{l.title}}</div>
                                    <div class="live-sub">{{l.subtitle}}</div>
                                </div>
                                <div class="live-btn disable" @click.stop v-if="l.es == 3">报名已结束</div>
                                <div class="live-btn" @click.stop="enroll(`${tab}_${i}`)" v-else-if="l.es">报名探校</div>
                                <div class="live-btn disable" @click.stop v-else>报名未开始</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="other-info" v-html="info.other" v-if="info.other"></div>
        </div>
        <transition name="fade">
            <div class="cover" v-if="info && info.cover && cover">
                <img :src="info.cover" @load="hideCover">
            </div>
        </transition>
    </div>
</template>

<script>
    import {wxConf} from "../common/wxTool";
    import {overscroll} from "../common/tool";

    export default {
        name: "SchHome",
        data() {
            return {
                tab: 0,
                cover: true,
            }
        },
        computed: {
            info() {
                let info = this.$store.getters.info;
                info && this.init(info);
                return info;
            },
            tabs() {
                return this.$store.getters.tabs;
            },
            admission() {
                return this.$store.getters.admission;
            },
            list() {
                let tabs = this.tabs, tab = this.tab;
                return tabs && tabs[tab] ? tabs[tab].list : null;
            }
        },
        mounted() {
            overscroll(document.querySelector(".content"));
        },
        methods: {
            init (info) {
                if(info.cover) {
                    this.cover = true;
                } else {
                    this.cover = false;
                }
                this.wxInit(info);
            },
            hideCover() {
                setTimeout(() => {
                    this.cover = false;
                    this.$nextTick(this.mapInit);
                }, 1000)
            },
            showModal() {
                if(this.admission) {
                    this.$showModal({...this.admission});
                }
            },
            goToLive(l) {
                location.href = l.url
            },
            enroll(index) {
                this.$router.push({name: 'SchEnroll', params: {index}})
            },
            wxInit (info) {
                let imgUrl = info.share_logo ||  "https://zk-static-1301841918.cos.ap-nanjing.myqcloud.com/tencent.jpg";
                let title = info.share_title || info.title;
                let desc = info.share_desc || info.title;
                wxConf(title, desc, imgUrl);
            },
        }
    }
</script>

<style scoped lang="less">
    @import "../common/less/normal";
    .ctx {
        background-color: @backWhiteColor;
    }
    .other-info {
        padding: 20px 32px;
    }
    .detail {
        padding: 20px;
    }
    .cover {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        font-size: 0;
        overflow: hidden;
        z-index: 2;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .tab {
        display: flex;
        margin: 12px 0;
        font-size: 0;
    }
    .tab-item {
        flex: 1;
        position: relative;
        padding: 20px 12px;
        font-weight: 600;
        font-size: 32px;
        color: @tipFontColor;
        text-align: center;
        &.active {
            color: @titleFontColor;
            .tab-line {
                display: block;
            }
        }
        .tab-line {
            display: none;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            margin: 0 auto;
            height: 4px;
            background-color: @titleFontColor;
        }
    }
    .live-list {
        padding-top: 12px;
    }
    .live-item {
        margin-top: 12px;
        padding: 12px;
        &:active {
            background-color: @backGreyColor;
        }
    }
    .live-img {
        position: relative;
        height: 360px;
        border-radius: 8px;
        background: center no-repeat;
        background-size: cover;
        overflow: hidden;
        .live-play {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0,0,0,.2);
            &::before {
                content: '\e601';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                width: 100px;
                height: 100px;
                font-size: 100px;
                font-family: iconfont;
                line-height: 100px;
                color: #fff;
            }
        }
    }
    .live-time {
        position: absolute;
        top: 0;
        right: 0;
        padding: 0 12px;
        height: 48px;
        line-height: 48px;
        font-size: 24px;
        background-color: @primaryColor;
        color: var(--back-font-color);
        &.status-1 {
            background-color: @primaryColor;
        }
        &.status-2 {
            background-color: var(--success-color);
        }
        &.status-3 {
            background-color: @orangeColor;
        }
    }
    .live-info {
        display: flex;
        align-items: center;
        margin-top: 20px;
    }
    .live-txt {
        flex: 1;
    }
    .live-title {
        font-size: 30px;
        color: @titleFontColor;
    }
    .live-sub {
        margin-top: 12px;
        font-size: 26px;
        color: @tipFontColor;
    }
    .live-btn {
        padding: 0 20px;
        height: 54px;
        line-height: 54px;
        background-color: @primaryColor;
        border-radius: 8px;
        color: var(--back-white-color);
        font-size: 26px;
        &.disable {
            background-color: @tipFontColor;
        }
    }
    .admission {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        bottom: constant(safe-area-inset-bottom);
        bottom: env(safe-area-inset-bottom);
        height: 100px;
        border-top: 1px solid @borderColor;
        background-color: @backWhiteColor;
        z-index: 1;
        text-align: center;
        line-height: 100px;
        font-size: 32px;
    }
    .admission ~ .ctx {
        margin-bottom: 124px;
    }
</style>
